var React = require('react');

function IconError (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#9e9e9e","d":"M12.8 17.6h2.4V20h-2.4zm0-9.6h2.4v7.2h-2.4zm1.188-6A12 12 0 1 0 26 14 11.994 11.994 0 0 0 13.988 2zM14 23.6a9.6 9.6 0 1 1 9.6-9.6 9.6 9.6 0 0 1-9.6 9.6z","transform":"translate(-2 -2)"}));
}

IconError.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IconError;

IconError.default = IconError;
